/**
 * Auth API
 * Partner login and session (for service requests dashboard)
 */

import { apiClient } from './apiClient';

export interface PartnerUser {
  id: string;
  phone: string;
  userType: string;
  profile?: { fullName?: string };
}

export interface LoginResponse {
  user: PartnerUser;
  token: string;
}

/**
 * Partner login (phone + password)
 */
export async function partnerLogin(
  phone: string,
  password: string
): Promise<LoginResponse> {
  const normalizedPhone = phone.replace(/\D/g, '');
  const response = await apiClient.post<LoginResponse>(
    '/loyalty/auth/partner/login',
    { phone: normalizedPhone, password }
  );

  if (response.success && response.data) {
    const d = response.data as any;
    return {
      user: d.user,
      token: d.token,
    };
  }

  throw new Error(response.message || 'Login failed');
}

/**
 * Get current user (requires auth token)
 */
export async function getMe(): Promise<PartnerUser> {
  const response = await apiClient.get<PartnerUser>('/loyalty/auth/me');

  if (response.success && response.data) {
    const d = response.data as any;
    const u = d.user || d;
    return {
      id: u._id ?? u.id,
      phone: u.phone ?? '',
      userType: u.userType ?? 'partner',
      profile: u.profile,
    };
  }

  throw new Error(response.message || 'Failed to fetch user');
}
